import buyDomainBR from './buyDomain.br';
import buyDomainMX from './buyDomain.mx';
import buyDomainCL from './buyDomain.cl';
import buyDomainCO from './buyDomain.co';

const buyDomain = {
  BR: buyDomainBR,
  MX: buyDomainMX,
  CL: buyDomainCL,
  CO: buyDomainCO,
};

export default buyDomain;
